export const socialMediaLinks = {
  facebook: "https://www.facebook.com/Valmeego-100782859400029/",
  instagram: "https://www.instagram.com/valmeego/",
  twitter: "https://twitter.com/valmeego",
  linkedIn: "https://www.linkedin.com/company/valmeego/",
  youTube: "https://www.youtube.com/channel/UC0ep6rqOfyBUAOYwOzuMjpA",
  tiktok: "https://www.tiktok.com/@valmeego",
};
